import { gql, useMutation } from '@apollo/client';

const GENERATE_QR_CODE = gql`
    mutation GenerateQRCode($input: QRCodeInput!) {
        generateQrCode(input: $input) {
            success
            error
            dataUrl
            filename
        }
    }
`;

/*
 * Hook to generate QR code and automatically download it
 */
export const useGenerateQRCodeWithDownload = () => {
    const [generateQRCode, { loading, error }] = useMutation(GENERATE_QR_CODE);

    const generateAndDownload = async params => {
        const { type = 'png', data, logoUrl, filename = 'QRCode', size = 2000, logoSizeRatio = 0.2 } = params;

        if (!type || !['png', 'svg'].includes(type)) {
            throw new Error('Invalid type. Must be "png" or "svg"');
        }

        if (!data) {
            throw new Error('QR code data is required');
        }

        try {
            const result = await generateQRCode({
                variables: {
                    input: {
                        data,
                        format: type,
                        size,
                        logoUrl,
                        logoSizeRatio,
                    },
                },
            });

            const { generateQrCode } = result.data;

            if (!generateQrCode.success) {
                throw new Error(generateQrCode.error || 'Failed to generate QR code');
            }

            // Download the file using the data URL
            const { dataUrl, filename: suggestedFilename } = generateQrCode;

            // Create a link element to trigger download
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = filename ? `${filename}.${type}` : suggestedFilename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            console.error('Error generating QR code:', err);
            throw err;
        }
    };

    return [generateAndDownload, { loading, error }];
};
